import React, { Component } from 'react';
import PropTypes from 'prop-types';

const parentStyles = {
  overflow: 'hidden',
  position: 'relative',
};

const defaultStyles = {
  position: 'relative',
  overflow: 'hidden',
  cursor: 'pointer',
  display: 'block',
  float: 'left',
};

const Star = ({ char, color, size, index, clicked }) => {
  const style = Object.assign({}, defaultStyles, {
    color,
    cursor: 'pointer',
    fontSize: `${size}px`,
  });

  return (
    <span style={style} data-index={index} onClick={clicked}>
      {char}
    </span>
  );
};

class Stars extends Component {
  constructor(props) {
    super(props);

    // set defaults
    props = Object.assign({}, props);
    if (props.value) {
      this.state = {
        lower: props.value.lower ? props.value.lower : 0,
        upper: props.value.upper ? props.value.upper : 0,
        stars: [],
      };
    } else {
      this.state = {
        lower: 0,
        upper: 0,
        stars: [],
      };
    }

    this.state.config = {
      count: props.count,
      size: props.size,
      char: props.char,
      cancel: props.cancel,
      // default color of inactive star
      color1: props.color1,
      // color of an active star
      color2: props.color2,
      edit: props.edit,
    };

    this.clicked = this.clicked.bind(this);
  }

  componentDidMount() {}

  componentWillReceiveProps(props) {
    let lower = 0;
    let upper = 0;
    if (props.value) {
      lower = props.value.lower ? props.value.lower : 0;
      upper = props.value.upper ? props.value.upper : 0;
    }

    this.setState({
      lower,
      upper,
      config: Object.assign({}, this.state.config, {
        count: props.count,
        size: props.size,
        char: props.char,
        color1: props.color1,
        color2: props.color2,
        edit: props.edit,
      }),
    });
  }

  clicked(event) {
    // Set the upper and lower bounds based on which index was clicked on
    // Ranges are always saved as lower bound included, upper bound excluded
    // Save upper as index + 1
    const index = Number(event.target.getAttribute('data-index'));
    let { lower, upper } = this.state;
    //console.log('Clicked on ', lower, upper, index);
    // Handle Reset to 0 case
    if (index === 0) {
      lower = 0;
      upper = 0;
      this.setState({
        lower,
        upper,
      });
      this.props.onChange({ lower, upper });
      return;
    }
    // Handle no range is set yet case
    if (!this.state.lower) {
      lower = index;
      upper = index + 1;
      this.setState({
        lower,
        upper,
      });
      this.props.onChange({ lower, upper });
      return;
    }
    if (this.state.lower === index) {
      if (this.state.upper < index + 1) {
        upper = index + 1;
      }
      // else do nothing
    }
    if (this.state.lower < index) {
      lower = index;
      if (this.state.upper === index + 1) {
        upper = index + 1;
      }
      if (this.state.upper > index) {
        upper = index + 1;
      }
      if (this.state.upper < index) {
        upper = index + 1;
      }
    }

    if (this.state.lower > index) {
      lower = index;
      if (this.state.upper <= index) {
        upper = index + 1;
      }
    }
    this.setState({
      lower,
      upper,
    });
    this.props.onChange({ lower, upper });
  }

  renderStars() {
    const { config } = this.state;
    const { lower, upper } = this.state;
    const { color1, color2, size, char, cancel } = config;
    const stars = [];
    stars.push(
      <Star
        key={0}
        index={0}
        active={false}
        size={size}
        char={cancel}
        clicked={this.clicked}
        color={color1}
      />
    );
    for (let i = 1; i < this.props.count + 1; i++) {
      if (i >= lower && i < upper) {
        //console.log('Active: ', lower, upper, i);
        stars.push(
          <Star
            key={i}
            index={i}
            active
            size={size}
            char={char}
            clicked={this.clicked}
            mouseOver={this.mouseOver}
            color={color2}
          />
        );
      } else {
        //console.log('Inactive: ', lower, upper, i);
        stars.push(
          <Star
            key={i}
            index={i}
            active={false}
            size={size}
            char={char}
            clicked={this.clicked}
            mouseOver={this.mouseOver}
            color={color1}
          />
        );
      }
    }

    return stars;
  }

  render() {
    const { className } = this.props;

    return (
      <div className={className} style={parentStyles}>
        {this.renderStars()}
      </div>
    );
  }
}

Stars.propTypes = {
  className: PropTypes.string,
  edit: PropTypes.bool,
  value: PropTypes.object,
  count: PropTypes.number,
  char: PropTypes.string,
  cancel: PropTypes.string,
  size: PropTypes.number,
  color1: PropTypes.string,
  color2: PropTypes.string,
  onChange: PropTypes.func,
};

Stars.defaultProps = {
  edit: true,
  half: true,
  lower: 0,
  upper: 0,
  count: 5,
  char: '★',
  // cancel: '❌',
  cancel: '[clear]',
  size: 15,
  color1: 'gray',
  color2: '#ffd700',

  onChange: () => {},
};

export default Stars;



// WEBPACK FOOTER //
// src/components/Stars/Stars.js